import React from 'react';
import Intro from './components/intro/Intro';
import About from './components/about/About';
import ProductList from './components/productList/ProductList';
import Contact from './components/contact/Contact';

const App = () => {

  return (
    <div style={{backgroundColor:"#080f16", display:'flex', flexDirection:'column', alignItems:'center' }}>
      <div style={{maxWidth:"2000px"}}>
      <Intro />
      <About />
      <ProductList />
      </div>
      <Contact />
    </div>
  );
};

export default App;
